import { isDev } from '.';

const firebaseConfig = {
  production: {
    apiKey: "AIzaSyD1lh0QxL0Eut-D1uhNACYQhOIZbP2B9iY",
    authDomain: "ats-prod-f2177.firebaseapp.com",
    projectId: "ats-prod-f2177",
    storageBucket: "ats-prod-f2177.appspot.com",
    messagingSenderId: "1082632729436",
    appId: "1:1082632729436:web:f6e68ace3f316339d08799",
    databaseURL: "https://ats-prod-f2177.asia-southeast1.firebasedatabase.app",
  },
  development: {
    apiKey: "AIzaSyDWUxiHrTKuTJAI3QApwT8KVF6lecBkhIM",
    authDomain: "ats-dev-d9077.firebaseapp.com",
    databaseURL: "https://ats-dev-d9077-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ats-dev-d9077",
    storageBucket: "ats-dev-d9077.appspot.com",
    messagingSenderId: "633021494234",
    appId: "1:633021494234:web:11b7b955fb4a3a8721c6e3",
    measurementId: "G-GR867W6GS7",
  },
};

export default firebaseConfig[isDev ? 'development' : 'production'];